import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import styled from 'styled-components'

export const StyledToastContainer = styled(ToastContainer).attrs({
  className: '',
  toastClassName: '',
  bodyClassName: '',
  progressClassName: ''
})`
  --toastify-color-light: none;
  --toastify-toast-width: 352px;
  --toastify-toast-max-height: 116;

  // https://styled-components.com/docs/faqs#how-can-i-override-styles-with-higher-specificity
  &&&.Toastify__toast-container {
  }
  .Toastify__toast {
    margin-bottom: 8px;
    padding: 0;
    border-left: 0 !important;
  }
  .Toastify__toast-body {
    padding: 0;
  }
  .Toastify__progress-bar {
  }
  //FIXME: shadow root of tds-toast is unreachable so mobile styles are not applied

  /* @media (max-width: ${({ theme }) => theme.size.md}) {
    width: 100%;
    padding-right: 16px;
    left: 0;
    margin: 0;
    bottom: 0;
    transform: translateX(0);

    .content {
      width: 100%;
      max-width: 100%;
    }

    .header-subheader {
      width: 100%;
    }

    .wrapper {
      width: 100%;
    }
  } */
`
